<div id="admissions-prospectus" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Prospectus</h2>
    <p class="inner-lead mt-3">
      The College Prospectus provides comprehensive information about Shah Satnam Ji Girls' College, Sirsa — including
      all academic programmes offered, fee structures, admission procedures, facilities, rules, and regulations.
    </p>

    <!-- Tab Navigation -->
    <div class="report-tabs-wrapper mb-4">
      <div class="report-tabs">
        <button class="tab-btn" [class.active]="activeTab === '2026-27'" (click)="setActiveTab('2026-27')">
          <i class="fa-solid fa-book-open me-2"></i> Prospectus 2026–27
        </button>
        <button class="tab-btn" [class.active]="activeTab === '2025-26'" (click)="setActiveTab('2025-26')">
          <i class="fa-solid fa-book me-2"></i> Prospectus 2025–26 & 2024–25
        </button>
      </div>
    </div>

    <!-- Active PDF Viewer Section -->
    <div *ngIf="activeTab === '2026-27'" class="animate-fade-in">
      <div class="pdf-block">
        <pdf-viewer src="/assets/pdf/admission/Enrollment Handbook 2027.pdf" [render-text]="true"
          [original-size]="false" style="width:100%; height:680px; display:block;">
        </pdf-viewer>
      </div>

      <div class="mt-4 d-flex flex-wrap gap-3 justify-content-center">
        <a href="/assets/pdf/admission/Enrollment Handbook 2027.pdf" target="_blank" class="pdf-download-btn">
          <i class="fa fa-download me-2"></i> Download Prospectus 2026–27
        </a>
        <a href="/assets/pdf/admission/PROSPECTUS_merged.pdf" target="_blank" class="pdf-download-btn">
          <i class="fa fa-download me-2"></i> Download Prospectus 2025–26 & 2024–25
        </a>
      </div>
    </div>

    <div *ngIf="activeTab === '2025-26'" class="animate-fade-in">
      <div class="pdf-block">
        <pdf-viewer src="/assets/pdf/admission/PROSPECTUS_merged.pdf" [render-text]="true" [original-size]="false"
          style="width:100%; height:680px; display:block;">
        </pdf-viewer>
      </div>

      <div class="mt-4 d-flex flex-wrap gap-3 justify-content-center">
        <a href="/assets/pdf/admission/PROSPECTUS_merged.pdf" target="_blank" class="pdf-download-btn">
          <i class="fa fa-download me-2"></i> Download Prospectus 2025–26 & 2024–25
        </a>
        <a href="/assets/pdf/admission/Enrollment Handbook.pdf" target="_blank" class="pdf-download-btn">
          <i class="fa fa-download me-2"></i> Download Prospectus 2026–27
        </a>
      </div>
    </div>

  </div>
</div>